
export const addCSSLink = ( fonts: string[] ) => {
    const fs = fonts.map(f => {
        return `${f.replaceAll(" ", "+")}:regular,italic,bold,bolditalic`
    }) 

    const el3: any = document.createElement("link")  
    el3.href=`https://fonts.googleapis.com/css?family=${ fs.join("|") }&display=swap` 
    el3.rel="stylesheet"
    el3.type="text/css" 
    document.getElementsByTagName("head")[0].prepend(el3) 
}